import { render, staticRenderFns } from "./DividerBlock.vue?vue&type=template&id=3701699c&scoped=true"
import script from "./DividerBlock.vue?vue&type=script&lang=js"
export * from "./DividerBlock.vue?vue&type=script&lang=js"
import style0 from "./DividerBlock.vue?vue&type=style&index=0&id=3701699c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3701699c",
  null
  
)

export default component.exports